import Prose from './prose.styled'

export default Prose
